import "./MoreInformation.css";
export const VestingShares = (
  <div className="info-container small flex flex-row mr-auto ml-auto">
    <div className="info-column small flex flex-column ">
      <text className="sub-title">All shares is the standard practice</text>
      <text className="paragraph">
        It is rather common for all of the founder’s shares to be subject to
        vesting, especially in the early stage of the company. Shares that are
        left out of the vesting schedule, won’t be subject to the call options
        in case of a leaver arrangements which opens the door to dead equity.
      </text>
      <text className="paragraph">
        This whole exercise is meant to avoid dead equity. That said, there
        could be specific circumstances which could argue for an exception on
        this principle. To be assessed on a case-by-case basis.
      </text>
    </div>
  </div>
);
